"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const http_1 = require("../utils/http");
const auth_api_1 = require("../utils/api/auth/auth.api");
const User_slice_1 = require("./slice/User.slice");
const user_api_1 = require("../utils/api/user/user.api");
const sos_remorquage_api_1 = require("../utils/api/sos-remorquage/sos-remorquage.api");
const comment_api_1 = require("../utils/api/comments/comment.api");
const notification_api_1 = require("../utils/api/notification/notification.api");
const categorie_api_1 = require("../utils/api/categorie/categorie.api");
const espace_api_1 = require("../utils/api/espace/espace.api");
const direction_api_1 = require("../utils/api/direction/direction.api");
const option_api_1 = require("../utils/api/option/option.api");
const point_peage_api_1 = require("../utils/api/point-peage/point-peage.api");
const tarif_api_1 = require("../utils/api/tarif/tarif.api");
const vehicule_api_1 = require("../utils/api/vehicule/vehicule.api");
const sos_notifications_api_1 = require("../utils/api/sos-notifications/sos-notifications.api");
const filtersSlice_1 = __importDefault(require("../features/filtersSlice"));
const metricsSlice_1 = __importDefault(require("../features/metricsSlice"));
const rapidos_api_1 = require("../utils/api/rapidos/rapidos.api");
const signalement_api_1 = require("../utils/api/signalement/signalement.api");
const faq_api_1 = require("../utils/api/faq/faq.api");
const store = (0, toolkit_1.configureStore)({
    reducer: {
        [auth_api_1.AuthApi.reducerPath]: auth_api_1.AuthApi.reducer,
        [User_slice_1.UserSlice.name]: User_slice_1.UserSlice.reducer,
        [user_api_1.UserApi.reducerPath]: user_api_1.UserApi.reducer,
        [sos_remorquage_api_1.SOSRemorquageApi.reducerPath]: sos_remorquage_api_1.SOSRemorquageApi.reducer,
        [comment_api_1.CommentApi.reducerPath]: comment_api_1.CommentApi.reducer,
        [notification_api_1.NotificationApi.reducerPath]: notification_api_1.NotificationApi.reducer,
        [categorie_api_1.CategorieApi.reducerPath]: categorie_api_1.CategorieApi.reducer,
        [espace_api_1.EspaceApi.reducerPath]: espace_api_1.EspaceApi.reducer,
        [direction_api_1.DirectionApi.reducerPath]: direction_api_1.DirectionApi.reducer,
        [option_api_1.OptionApi.reducerPath]: option_api_1.OptionApi.reducer,
        [point_peage_api_1.PointPeageApi.reducerPath]: point_peage_api_1.PointPeageApi.reducer,
        [tarif_api_1.TarifApi.reducerPath]: tarif_api_1.TarifApi.reducer,
        [vehicule_api_1.VehiculeApi.reducerPath]: vehicule_api_1.VehiculeApi.reducer,
        [sos_notifications_api_1.sosApi.reducerPath]: sos_notifications_api_1.sosApi.reducer,
        [faq_api_1.FaqApi.reducerPath]: faq_api_1.FaqApi.reducer,
        filters: filtersSlice_1.default,
        metrics: metricsSlice_1.default,
        [rapidos_api_1.RapidosApi.reducerPath]: rapidos_api_1.RapidosApi.reducer,
        [signalement_api_1.SignalementApi.reducerPath]: signalement_api_1.SignalementApi.reducer,
    },
    devTools: http_1.Env === http_1.currentEnv,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(auth_api_1.AuthApi.middleware, user_api_1.UserApi.middleware, sos_remorquage_api_1.SOSRemorquageApi.middleware, comment_api_1.CommentApi.middleware, notification_api_1.NotificationApi.middleware, categorie_api_1.CategorieApi.middleware, espace_api_1.EspaceApi.middleware, direction_api_1.DirectionApi.middleware, option_api_1.OptionApi.middleware, point_peage_api_1.PointPeageApi.middleware, tarif_api_1.TarifApi.middleware, vehicule_api_1.VehiculeApi.middleware, sos_notifications_api_1.sosApi.middleware, faq_api_1.FaqApi.middleware, rapidos_api_1.RapidosApi.middleware, signalement_api_1.SignalementApi.middleware),
});
exports.default = store;
